export const componentRef = 'col-browser-storage-setter';
